import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgImageSliderModule } from 'ng-image-slider';
import { LightboxModule } from 'ngx-lightbox';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';  
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { ReactiveFormsModule } from  '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DatePipePipes, DateFormat } from './date.pipe';

import { HeaderComponent } from './views/header/header.component';
import { FooterComponent } from './views/footer/footer.component';
import { HomeComponent } from './views/home/home.component';
import { AboutUsComponent } from './views/about-us/about-us.component';
import { PrincipalMsgComponent } from './views/principal-msg/principal-msg.component';
import { ManagerMsgComponent } from './views/manager-msg/manager-msg.component';
import { SalientFeaturesComponent } from './views/salient-features/salient-features.component';
import { ObjectivesComponent } from './views/objectives/objectives.component';
import { AddmissionComponent } from './views/addmission/addmission.component';
import { DisciplineComponent } from './views/discipline/discipline.component';
import { CodeOfParentsComponent } from './views/code-of-parents/code-of-parents.component';
import { CodeOfStudentsComponent } from './views/code-of-students/code-of-students.component';
import { TransportationComponent } from './views/transportation/transportation.component';
import { FeeComponent } from './views/fee/fee.component';
import { SchoolTimingComponent } from './views/school-timing/school-timing.component';
import { ImgGalleryComponent } from './views/img-gallery/img-gallery.component';
import { VideoGalleryComponent } from './views/video-gallery/video-gallery.component';
import { OnlineFeeComponent } from './views/online-fee/online-fee.component';
import { ContactUsComponent } from './views/contact-us/contact-us.component';
import { NoticesComponent } from './views/notices/notices.component';
import { ThanksComponent } from './views/thanks/thanks.component';
import { ExpectationsComponent } from './views/expectations/expectations.component';
import { PrayersComponent } from './views/prayers/prayers.component';
import { UniformComponent } from './views/uniform/uniform.component';
import { WithdrawalComponent } from './views/withdrawal/withdrawal.component';
import { ToppersComponent } from './views/toppers/toppers.component';
import { AchievementsComponent } from './views/achievements/achievements.component';
import { StuHeadsComponent } from './views/stu-heads/stu-heads.component';
import { CabinetComponent } from './views/cabinet/cabinet.component';
import { StaffGroupComponent } from './views/staff-group/staff-group.component';
// import { GuestBookComponent } from './views/guest-book/guest-book.component';
import { SitemapComponent } from './views/sitemap/sitemap.component';
import { ImageDetailsComponent } from './views/image-details/image-details.component';
import { StaffComponent } from './views/staff/staff.component';
import { BirthdayComponent } from './views/birthday/birthday.component';
import { FounderComponent } from './views/founder/founder.component';
import { VisionComponent } from './views/vision/vision.component';
import { SoonComponent } from './views/soon/soon.component';
import { CarouselComponent } from './views/carousel/carousel.component';
import { ExmintionComponent } from './views/exmintion/exmintion.component';
import { TipsComponent } from './views/tips/tips.component';
import { ProfileComponent } from './views/profile/profile.component';
import { SkillsComponent } from './views/skills/skills.component';
import { CommitteesComponent } from './views/committees/committees.component';
import { MottoComponent } from './views/motto/motto.component';
import { PrayasComponent } from './views/prayas/prayas.component';
import { HeadboyComponent } from './views/headboy/headboy.component';
import { HeadgirlComponent } from './views/headgirl/headgirl.component';
import { NccComponent } from './views/ncc/ncc.component';
import { FacilitiesComponent } from './views/facilities/facilities.component';
import { ActivitesComponent } from './views/activites/activites.component';
import { FutureComponent } from './views/future/future.component';
import { TripComponent } from './views/trip/trip.component';
import { CeromonyComponent } from './views/ceromony/ceromony.component';
import { TeacherComponent } from './views/teacher/teacher.component';
import { TrusteeComponent } from './views/trustee/trustee.component';
import { CertificatesComponent } from './views/certificates/certificates.component';
import { AcadmicsComponent } from './views/acadmics/acadmics.component';
import { CurriculamComponent } from './views/curriculam/curriculam.component';
import { AssessmentComponent } from './views/assessment/assessment.component';
import { PromotionComponent } from './views/promotion/promotion.component';
import { PatronComponent } from './views/patron/patron.component';
import { DirectorComponent } from './views/director/director.component';
import { PledgeComponent } from './views/pledge/pledge.component';
import { AdministrationComponent } from './views/administration/administration.component';
import { AffilationComponent } from './views/affilation/affilation.component';
import { MediumComponent } from './views/medium/medium.component';
import { ExaminationComponent } from './views/examination/examination.component';
import { LeaveRuleComponent } from './views/leave-rule/leave-rule.component';
import { LibComponent } from './views/lib/lib.component';
import { Prayer2Component } from './views/prayer2/prayer2.component';
import { GeneralHintsComponent } from './views/general-hints/general-hints.component';
import { SpiritualHintsComponent } from './views/spiritual-hints/spiritual-hints.component';
import { BehaviourComponent } from './views/behaviour/behaviour.component';
import { CardsComponent } from './views/cards/cards.component';
import { HelpsComponent } from './views/helps/helps.component';
import { ProudComponent } from './views/proud/proud.component';
import { FeeStructureComponent } from './views/fee-structure/fee-structure.component';



@NgModule({
  declarations: [    
    AppComponent,
    DatePipePipes,
    DateFormat,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    AboutUsComponent,
    PrincipalMsgComponent,
    ManagerMsgComponent,
    SalientFeaturesComponent,
    ObjectivesComponent,
    AddmissionComponent,
    DisciplineComponent,
    CodeOfParentsComponent,
    CodeOfStudentsComponent,
    TransportationComponent,
    FeeComponent,
    SchoolTimingComponent,
    ImgGalleryComponent,
    VideoGalleryComponent,
    OnlineFeeComponent,
    ContactUsComponent,
    NoticesComponent,
    ThanksComponent,
    ExpectationsComponent,
    PrayersComponent,
    UniformComponent,
    WithdrawalComponent,
    ToppersComponent,
    AchievementsComponent,
    StuHeadsComponent,
    CabinetComponent,
    StaffGroupComponent,
    // GuestBookComponent,
    SitemapComponent,
    ImageDetailsComponent,
    StaffComponent,
    BirthdayComponent,
    FounderComponent,
    VisionComponent,
    SoonComponent,
    CarouselComponent,
    ExmintionComponent,
    TipsComponent,
    ProfileComponent,
    SkillsComponent,
    CommitteesComponent,
    MottoComponent,
    PrayasComponent,
    HeadboyComponent,
    HeadgirlComponent,
    NccComponent,
    FacilitiesComponent,
    ActivitesComponent,
    FutureComponent,
    TripComponent,
    CeromonyComponent,
    TeacherComponent,
    TrusteeComponent,
    CertificatesComponent,
    AcadmicsComponent,
    CurriculamComponent,
    AssessmentComponent,
    PromotionComponent,
    PatronComponent,
    DirectorComponent,
    PledgeComponent,
    AdministrationComponent,
    AffilationComponent,
    MediumComponent,
    ExaminationComponent,
    LeaveRuleComponent,
    LibComponent,
    Prayer2Component,
    GeneralHintsComponent,
    SpiritualHintsComponent,
    BehaviourComponent,
    CardsComponent,
    HelpsComponent,
    ProudComponent,
    FeeStructureComponent
  ],
  imports: [
    NgImageSliderModule,
    NgbModule,
    LightboxModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AngularMaterialModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
